export default __webpack_public_path__ + "static/media/PrintIcon.5bab5e0d.svg";